export default __webpack_public_path__ + "static/media/Blog12.17.08544e32.png";